const parallax = () => {
    const TABLET_BREAKPOINT = 991;
    let isDesktop = window.innerWidth >= TABLET_BREAKPOINT;

    const projectItems = Array.from(
        document.querySelectorAll('.projects__item')
    );
    let lastScrollY = window.scrollY;
    const cachedItems = [];

    function updateItems() {
        cachedItems.length = 0;
        projectItems.forEach((item) => {
            cachedItems.push({
                item,
                bg: item.querySelector('.bg-thumbnail'),
                stick: item.querySelector('.stick'),
            });
        });
    }

    function resetTransforms() {
        cachedItems.forEach(({ bg, stick }) => {
            if (bg) bg.style.transform = '';
            if (stick) stick.style.transform = '';
        });
    }

    function handleResize() {
        const wasDesktop = isDesktop;
        isDesktop = window.innerWidth >= TABLET_BREAKPOINT;
        
        updateItems();
        
        // Скинути трансформації при переході на mobile
        if (wasDesktop && !isDesktop) {
            resetTransforms();
        }
    }

    window.addEventListener('resize', handleResize);
    updateItems();

    function applyParallaxTransform(element, fallbackSpeed, offset) {
        if (!element || !isDesktop) return;
        const speed = parseFloat(element.dataset.speed) || fallbackSpeed;
        const translateY = offset * -speed;
        element.style.transform = `translate3d(0, ${translateY}px, 0)`;
    }

    function updateParallax() {
        if (!isDesktop) return;
        
        const viewportHeight = window.innerHeight;

        cachedItems.forEach(({ item, bg, stick }) => {
            const rect = item.getBoundingClientRect();
            const offset = rect.top + rect.height / 2 - viewportHeight / 2;

            applyParallaxTransform(bg, 0.8, offset);
            applyParallaxTransform(stick, 0.5, offset);
        });
    }

    function onFrame() {
        const currentScrollY = window.scrollY;
        if (currentScrollY !== lastScrollY) {
            updateParallax();
            lastScrollY = currentScrollY;
        }
        requestAnimationFrame(onFrame);
    }

    requestAnimationFrame(onFrame);
};

export default parallax;
